// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"406ba5c9","977":"82a5bc53"}[chunkId] + ".chunk.js";
};